import AccessFeatureAlert from './Alert';
import AccessFeatureAutoComplete from './AutoComplete';
import AccessFeatureBadge from './Badge';
import AccessFeatureButton from './Button';
import AccessFeatureFormControlLabel from './FormControlLabel';
import AccessFeatureGate from './Gate';
import AccessFeatureHidden from './Hidden';
import AccessFeatureListField from './ListField';
import AccessFeatureListItemButton from './ListItemButton';
import AccessFeatureMenuItem from './MenuItem';
import AccessFeatureModal from './Modal';
import AccessFeatureNextPlanChip from './NextPlanChip';
import AccessFeatureTab from './Tab';
import AccessFeatureTabPanel from './TabPanel';
import AccessFeatureTextField from './TextField';
import AccessFeatureTypograhpy from './Typograhpy';
import { AccessFeatureUpgradePlanButtonComponents } from './UpgradePlanButton';

const FeatureAccessComponents = {
  Alert: AccessFeatureAlert,
  AutoComplete: AccessFeatureAutoComplete,
  Badge: AccessFeatureBadge,
  Button: AccessFeatureButton,
  FormControlLabel: AccessFeatureFormControlLabel,
  Gate: AccessFeatureGate,
  Hidden: AccessFeatureHidden,
  ListField: AccessFeatureListField,
  ListItemButton: AccessFeatureListItemButton,
  MenuItem: AccessFeatureMenuItem,
  Modal: AccessFeatureModal,
  NextPlanChip: AccessFeatureNextPlanChip,
  Tab: AccessFeatureTab,
  TabPanel: AccessFeatureTabPanel,
  TextField: AccessFeatureTextField,
  Typograghy: AccessFeatureTypograhpy,
  UpgradePlanButton: AccessFeatureUpgradePlanButtonComponents,
};

export default FeatureAccessComponents;
